import {GRAPH_COLORS} from "./constants/S360_constants";

export const getColorForUserType = (obj) =>
{
    switch (obj.name)
    {
        case 'Teacher':
            return GRAPH_COLORS.GRAPH_COLOR_1;
            break;
        case 'System Admin':
            return GRAPH_COLORS.GRAPH_COLOR_2;
            break;
        case 'GDPR User':
            return GRAPH_COLORS.GRAPH_COLOR_3;
            break;
        case 'School Support User':
            return GRAPH_COLORS.GRAPH_COLOR_4;
            break;
        case 'Governor':
            return GRAPH_COLORS.GRAPH_COLOR_5;
            break;
        case 'Parent':
            return GRAPH_COLORS.GRAPH_COLOR_6;
            break;
        case 'Pupil':
            return GRAPH_COLORS.GRAPH_COLOR_7;
            break;
        case 'School Admin':
            return GRAPH_COLORS.GRAPH_COLOR_8;
            break;
        case 'SI Admin':
            return GRAPH_COLORS.GRAPH_COLOR_9;
            break;
        case 'SI User':
            return GRAPH_COLORS.GRAPH_COLOR_10;
            break;
        case 'EYFS Admin':
            return GRAPH_COLORS.GRAPH_COLOR_15;
        case 'EYFS User':
            return GRAPH_COLORS.GRAPH_COLOR_16;
            break;
        case 'Kitchen Staff':
            return GRAPH_COLORS.GRAPH_COLOR_11;
            break;
        default:
            return GRAPH_COLORS.GRAPH_COLOR_9;
            break;
    }
}

export const getColorForResource = (obj) =>
{
    switch (obj.name) {
        case 'Encyclopedia':
            return GRAPH_COLORS.GRAPH_COLOR_1;
            break;
        case 'Canva':
            return GRAPH_COLORS.GRAPH_COLOR_2;
            break;
        case 'Busy Things':
            return GRAPH_COLORS.GRAPH_COLOR_3;
            break;
        case '2SimplePM':
            return GRAPH_COLORS.GRAPH_COLOR_4;
            break;
        case 'CS First':
            return GRAPH_COLORS.GRAPH_COLOR_5;
            break;
        case 'J2E':
            return GRAPH_COLORS.GRAPH_COLOR_6;
            break;
        case 'Book Creator':
            return GRAPH_COLORS.GRAPH_COLOR_7;
            break;
        case 'Home Learning':
            return GRAPH_COLORS.GRAPH_COLOR_8;
            break;
        case 'Adobe Express':
            return GRAPH_COLORS.GRAPH_COLOR_9;
            break;
        case 'Be Internet Awesome':
            return GRAPH_COLORS.GRAPH_COLOR_10;
            break;
        case 'BBC Bitesize':
            return GRAPH_COLORS.GRAPH_COLOR_11;
            break;
        case 'Curriculum Visions':
            return GRAPH_COLORS.GRAPH_COLOR_12;
            break;
        case 'Discovery':
            return GRAPH_COLORS.GRAPH_COLOR_13;
            break;
        case 'Shoofly':
            return GRAPH_COLORS.GRAPH_COLOR_14;
            break;
        default:
            return '#ff7c43';
            break;
    }
}